import { BaseQueryParams } from 'types/base-query-params';
import { PaginatedResponse } from 'types/dtos';
import { ResponseCompanyOwnerDto } from '../types/dtos';
import { BaseQueryFn, EndpointBuilder } from '@reduxjs/toolkit/query';
import { constructQueryParams } from 'utils/query-params-builder';
import { APP_ENDPOINTS } from 'app/endpoints';
import { formatDate } from 'utils/date-helpers';

export type CompanyOwnersQueryParams = BaseQueryParams;

export default (build: EndpointBuilder<BaseQueryFn, string, string>) =>
    build.query<PaginatedResponse<ResponseCompanyOwnerDto>, CompanyOwnersQueryParams>({
        async queryFn(_arg, _queryApi, _extraOptions, fetchWithBQ) {
            const companyOwnersResponse = await fetchWithBQ(constructQueryParams(APP_ENDPOINTS.COMPANY_OWNERS, _arg));

            if (companyOwnersResponse.error) {
                return { error: companyOwnersResponse.error };
            }

            const companyOwners = companyOwnersResponse.data as PaginatedResponse<ResponseCompanyOwnerDto>;

            companyOwners.content = companyOwners.content.map((companyOwner) => {
                const createdAt = formatDate(companyOwner.createdAt);

                return {
                    ...companyOwner,
                    createdAt,
                };
            });

            return {
                data: companyOwners,
            };
        },
        providesTags: [{ type: 'company-owners', id: 'GET' }],
    });
